import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { APP_INITIALIZER, ApplicationConfig } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withEnabledBlockingInitialNavigation, withInMemoryScrolling } from '@angular/router';
import Aura from '@primeng/themes/aura';
import { providePrimeNG } from 'primeng/config';
import { appRoutes } from './app.routes';
import { AuthInterceptor } from './app/auth.interceptor';
import { MessageService } from 'primeng/api';
import { LoadingInterceptor } from './app/loading.interceptor';
import { RuntimeConfigService } from './app/services/runtime-config.service';

function initializeRuntimeConfig(runtimeConfigService: RuntimeConfigService): () => Promise<void> {
    return () => runtimeConfigService.load();
}

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(appRoutes, withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' }), withEnabledBlockingInitialNavigation()),
        provideHttpClient(withFetch(), withInterceptors([AuthInterceptor, LoadingInterceptor])),
        provideAnimationsAsync(),
        providePrimeNG({ theme: { preset: Aura, options: { darkModeSelector: '.app-dark' } }, overlayOptions: { appendTo: 'body' } }),
        MessageService,
        {
            provide: APP_INITIALIZER,
            useFactory: initializeRuntimeConfig,
            deps: [RuntimeConfigService],
            multi: true
        }
    ]
};
